
import { Component, Input, OnInit, inject } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { ErrorStateMatcher } from '@angular/material/core';
import { CerrixIconComponent } from '../cerrix-icon/cerrix-icon.component';
import { ErrorMessagesPipe } from '../pipes/error-messages.pipe';
import { DefaultErrorStateMatcher } from '../validation/DefaultErrorStateMatcher';

@Component({
    selector: 'cerrix-color-picker-simple',
    imports: [
    ErrorMessagesPipe,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    CerrixIconComponent
],
    templateUrl: './cerrix-color-picker-simple.component.html',
    styleUrl: './cerrix-color-picker-simple.component.scss'
})
export class CerrixColorPickerSimpleComponent
  implements OnInit, ControlValueAccessor
{
  private readonly defaultColor: string = '#000000';
  protected errorMatcher!: ErrorStateMatcher;

  @Input() public value: string | undefined;

  @Input() public disabled: boolean = false;
  @Input() public allowEmpty: boolean = false;
  @Input() public dataUiid: string = "undefined"

  protected ngControl = inject(NgControl, { optional: true, self: true });

  private onValueChange = (value: string) => {};
  private onTouched = () => {};

  public writeValue(value: string): void {
    this.value = value;
  }
  public registerOnChange(onChange: (value: string) => void): void {
    this.onValueChange = onChange;
  }
  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }
  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  constructor() {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
      this.errorMatcher = new DefaultErrorStateMatcher();
    }
  }

  ngOnInit(): void {
    if (!this.allowEmpty) {
      this.value = this.defaultColor;
    }
  }

  protected onChange(event: Event) {
    this.value = (event.target as HTMLInputElement)?.value;
    this.onValueChange(this.value);
  }

  protected clearColor() {
    this.value = '';
    this.onValueChange(this.value);
  }
}
